import Vue from 'vue';
import VueRouter from 'vue-router';
import { getDashboardBaseUrl } from '@/utils/helpers';

import Guard from '@/apps/dashboard/services/middleware';
import Default from '@/apps/dashboard/001/layouts/Default';
import DefaultNoMemu from '@/apps/dashboard/001/layouts/DefaultNoMenu';
import Profile from '@/apps/dashboard/001/views/Profile';
import WorkPreferences from '@/apps/dashboard/001/views/WorkPreferences';
import AccountSettings from '@/apps/dashboard/001/views/AccountSettings';
import JobAlerts from '@/apps/dashboard/001/views/JobAlerts';
import SavedJobs from '@/apps/dashboard/001/views/SavedJobs';
import SavedSearches from '@/apps/dashboard/001/views/SavedSearches';
import logout from '@/apps/dashboard/001/views/Logout';
import Documents from '@/apps/dashboard/001/views/Documents';
import Applications from '@/apps/dashboard/001/views/Applications';
import Empty from '@/apps/dashboard/001/views/Empty';


Vue.use(VueRouter);

const routes = [
    {
        path: '/user-dashboard/spv', component: DefaultNoMemu,
        children: [
            { path: 'applications', name: 'applications-spv', component: Applications, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'profile', name: 'profile-spv', component: Profile, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'work-preferences', name: 'work-preferences-spv', component: WorkPreferences, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'documents', name: 'documents-spv', component: Documents, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'settings', name: 'settings-spv', component: AccountSettings, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'job-alerts', name: 'job-alerts-spv', component: JobAlerts, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'saved-jobs', name: 'saved-jobs-spv', component: SavedJobs, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'saved-searches', name: 'saved-searches-spv', component: SavedSearches, beforeEnter: Guard.redirectIfNotAuthenticated },
        ],
    },
    {
        path: '/', component: Default,
        children: [
            { path: '', name: 'index', component: Empty, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'applications', name: 'applications', component: Applications, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'profile', name: 'profile', component: Profile, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'work-preferences', name: 'work-preferences', component: WorkPreferences, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'documents', name: 'documents', component: Documents, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'settings', name: 'settings', component: AccountSettings, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'job-alerts', name: 'job-alerts', component: JobAlerts, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'saved-jobs', name: 'saved-jobs', component: SavedJobs, beforeEnter: Guard.redirectIfNotAuthenticated },
            { path: 'saved-searches', name: 'saved-searches', component: SavedSearches, beforeEnter: Guard.redirectIfNotAuthenticated },
        ],
    },
    {
        path: '/user-dashboard', component: DefaultNoMemu,
        children: [
            { path: 'logout', name: 'logout', component: logout },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    base: getDashboardBaseUrl(),
    routes,
});

Vue.use(router);

export default router;
